<template>
    <!-- Static et Lazy pour widgets -->
    <b-modal :static="Mantle.Config.modal.static" :lazy="Mantle.Config.modal.lazy" :size="size" :title="caption" v-model="dataShow" :hide-footer="true" cancel-variant="light">
        <InstanceSelector
                :searchArgs="searchArgs"
                :options="options"
                :columns="columns"
                :distinctFunction="distinctFunction"
                :searchFormStructure="searchFormStructure"
                v-model="dataValue"
                :quantityStep="quantityStep"
                :multiple="multiple"
                :distinct="distinct"
                @onAdd="onAdd"
                :data="data"
                :root="root">
        </InstanceSelector>
    </b-modal>
</template>

<script>
    import InstanceSelector from './InstanceSelector'
    export default {
        name: 'ModalInstanceSelector',
        components: {
            InstanceSelector,
        },
        props: {
            size: {
                type: String,
                default: 'lg'
            },
            root: {
                type: String,
                required: true
            },
            caption: {
                type: String,
                default: ''
            },
            subCaption: {
                type: String,
                default: ''
            },
            searchFormStructure: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            columns: {
                type: Array,
                default: function () {
                    return []
                }
            },
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            multiple: {
                type: Boolean,
                default: false
            },
            quantity: {
                type: Boolean,
                default: true
            },
            distinct: {
                type: Boolean,
                default: false
            },
            form: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: 'Aucun résultat',
                        borderVariant: '',
                        noBody: false
                    }
                }
            },
            quantityStep: {
                type: Number | String,
                default: 1
            },
            data: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            },
            distinctFunction: {
                type: Function,
                default: function () {
                    return false
                }
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataValue = val
                },
                deep: true
            },
            dataValue: {
                handler(val) {
                    if (this.multiple === false) {
                        this.open = false
                    }
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                   return this.dataShow
                }
            }
        },
        mounted() {
            this.dataValue = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataShow: false,
                dataValue: []
            }
        },
        methods: {
            onAdd(row, data) {
                this.$emit('onAdd', row, data)
            }
        }
    }
</script>
